export function asideLinksAccordion() {
  let linksBlock = $(".overview-links");

  $(document).on("click", ".overview-links .expand-links", function () {

      linksBlock.toggleClass("expanded");
      $(".lists-wrapper").slideToggle(300);

  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/aside-links-accordion.js